var script_loaded = false;
function loadJSscripts() {
    if (!script_loaded) {
        observer.disconnect();
        script_loaded = true;
        document.querySelectorAll("iframe.lazy").forEach(t => {
            const datasrc = t.dataset.src;
            if (datasrc != null) t.src = datasrc;
        });
        var t = document.getElementsByTagName("script");
        for (var i = 0; i < t.length; i++) {
            if (t[i].getAttribute("data-src") !== null) {
                t[i].setAttribute("src", t[i].getAttribute("data-src"));
                delete t[i].dataset.src;
            }
            if ("text/lazyload" == t[i].getAttribute("type")) {
                var e = document.createElement("script");
                for (var a = 0; a < t[i].attributes.length; a++) {
                    var n = t[i].attributes[a];
                    e.setAttribute(n.name, n.value);
                }
                e.type = "text/javascript";
                e.innerHTML = t[i].innerHTML;
                t[i].parentNode.removeChild(t[i]);
                t[i].parentNode.insertBefore(e, t[i]);
            }
        }
        var r = document.getElementsByTagName("link");
        for (i = 0; i < r.length; i++) {
            if (r[i].getAttribute("data-href") !== null) {
                r[i].setAttribute("href", r[i].getAttribute("data-href"));
                delete r[i].dataset.href;
            }
        }
        document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
    }
}
var optimizerActivityEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"];
optimizerActivityEvents.forEach(function (t) {
    window.addEventListener(t, loadJSscripts, false);
});
window.addEventListener ? window.addEventListener("load", function () { }, false) : window.attachEvent ? window.attachEvent("onload", function () { }) : window.onload = (t => { });